// extracted by mini-css-extract-plugin
export default {"informations":"U4iwljuZU3pmZEUF3jPA","badge":"_Gxg7pnC35oglIb42Esk"};